import React from 'react';
import JoinChallengeButton from '../JoinChallengeButton/JoinChallengeButton';
const MissionBlock = (props) => {
    const { mission } = props;
    return (React.createElement("div", { className: 'block block-mission block-mission-content' },
        React.createElement("img", { className: 'block-mission-background', src: mission.backgroundImage }),
        React.createElement("img", { className: 'block-mission-avatar', src: mission.avatarImage }),
        React.createElement("p", { className: 'block-mission-name' }, mission.name),
        React.createElement("div", { className: 'block-mission-button-container' },
            React.createElement(JoinChallengeButton, { url: mission.eventUrl, color: mission.color1, text: mission.joinButtonText }))));
};
export { MissionBlock };
